export default __webpack_public_path__ + "static/jointheteam-2b1dbe490e7a75b51f62994dbbc68d6e.jpg";